import React, { useEffect, useState } from "react";
import { SurfaceLoader } from "../components/feedback/DoARAsync";
import { getLoadedWorldModule, loadWorldModule } from "./worldModuleLoader";

// Extracted from App.jsx so the canonical WorldApp runtime can be mounted
// from more than one route (today: /world/:projectId and /space/:projectId)
// without duplicating the lazy-load-with-retry loading boundary. See
// docs/doar-core/DOARSPACE_UNIVERSAL_WORKSPACE_CONTRACT.md #2, #7.
function WorldRouteLoader() {
  return (
    <SurfaceLoader
      title="DoAR"
      detail="Opening your workspace…"
      slowDetail="Still opening this surface. You can retry without changing your saved work."
      onRetry={() => window.location.reload()}
      homeHref="/"
    />
  );
}

export default function WorldRoute() {
  const [worldModule, setWorldModule] = useState(() => getLoadedWorldModule());
  const [error, setError] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (worldModule?.default) return undefined;
    let live = true;
    setError(null);

    loadWorldModule()
      .then((module) => {
        if (live) setWorldModule(module);
      })
      .catch((err) => {
        if (live) setError(err || new Error("DoARSpace interface could not be loaded."));
      });

    return () => { live = false; };
  }, [attempt, worldModule]);

  if (worldModule?.default) {
    const LoadedWorldApp = worldModule.default;
    return <LoadedWorldApp />;
  }

  if (error) {
    return (
      <main className="doar-product-loader" role="alert" aria-live="assertive">
        <div className="doar-product-loader__mark" aria-hidden="true"><span/></div>
        <strong>Workspace needs a refresh</strong>
        <p>The DoARSpace interface did not finish loading. Your world and work are unchanged.</p>
        <div className="doar-product-loader__actions">
          <button type="button" onClick={() => setAttempt((value) => value + 1)}>Try again</button>
          <button type="button" onClick={() => window.location.reload()}>Refresh page</button>
          <a href="/">Go home</a>
        </div>
      </main>
    );
  }

  return <WorldRouteLoader />;
}
